import { useEffect, useState } from 'react';
import client from '../api/client';
export default function ApiKeys() {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { client.get('/admin/tenants?size=200').then(r=>setTenants(r.data.tenants||[])).finally(()=>setLoading(false)); }, []);
  return (
    <div>
      <h1 style={{ color:'#000', fontSize:22, fontWeight:700, margin:'0 0 8px', fontFamily:'Georgia,serif' }}>API Keys Overview</h1>
      <p style={{ color:'#555', margin:'0 0 24px', fontSize:14 }}>Tenants manage their own API keys. This shows who has API access.</p>
      <div style={{ background:'#fff', borderRadius:12, border:'1px solid #eee', overflow:'hidden', marginBottom:20 }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead><tr style={{ borderBottom:'1px solid #eee' }}>{['Tenant','Plan','API Access','Docs This Month'].map(h=><th key={h} style={{ color:'#555', fontSize:11, fontWeight:500, textAlign:'left', padding:'14px 16px', textTransform:'uppercase' }}>{h}</th>)}</tr></thead>
          <tbody>
            {loading?<tr><td colSpan={4} style={{ color:'#555', padding:24, textAlign:'center' }}>Loading...</td></tr>
            :tenants.map(t=>(
              <tr key={t.id} style={{ borderBottom:'1px solid #f5f5f5' }}>
                <td style={{ padding:'12px 16px' }}><div style={{ color:'#000', fontSize:14, fontWeight:500 }}>{t.name}</div><div style={{ color:'#555', fontSize:12 }}>{t.email}</div></td>
                <td style={{ padding:'12px 16px', color:'#333', fontSize:14 }}>{t.plan}</td>
                <td style={{ padding:'12px 16px' }}><span style={{ background:t.plan!=='FREE'?'#0f2a1a':'#f9f9f9', color:t.plan!=='FREE'?'#4caf7d':'#4a6580', padding:'3px 8px', borderRadius:4, fontSize:12, fontWeight:600 }}>{t.plan!=='FREE'?'ENABLED':'UPGRADE REQUIRED'}</span></td>
                <td style={{ padding:'12px 16px', color:'#333', fontSize:14 }}>{t.docs_this_month??0}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{ background:'#fff', borderRadius:12, padding:20, border:'1px solid #eee' }}>
        <div style={{ color:'#444', fontSize:13, fontWeight:600, marginBottom:8 }}>Integration Details</div>
        <div style={{ color:'#555', fontSize:13, lineHeight:1.8, fontFamily:'monospace' }}>
          POST https://ouresign.com/api/keys (tenant JWT required)<br/>
          GET  https://ouresign.com/api/external/ping<br/>
          POST https://ouresign.com/api/external/documents/upload<br/>
          Header: X-API-Key: oes_live_...
        </div>
      </div>
    </div>
  );
}
